function getPageInfo(window, pageList) {
  if (!pageList) {
    return null
  }
  const pages = pageList.pages || []

  function getPageById(pageId) {
    for (let i = 0; i < pages.length; ++i) {
      if (pages[i].pageId === pageId) {
        return pages[i]
      }
    }
  }

  const hash = window.location.hash.split('/')
  const pageId = hash[1]
  if (pageId) {
    const page = getPageById(pageId)
    if (page) {
      return page
    }
  }

  const pathname = window.location.pathname
  if (pathname) {
    for (let i = 0; i < pages.length; ++i) {
      const pageUriSEO = pages[i].pageUriSEO
      if (pageUriSEO) {
        const re = new RegExp(`(^|/)${pageUriSEO}(/|$)`)
        if (re.test(pathname)) {
          return pages[i]
        }
      }
    }
  }

  return pageList.mainPageId && getPageById(pageList.mainPageId)
}

export { getPageInfo }



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/utils.js